/**
 * Form v2 — Eski form/field/answer verisini canonical v2 şemasına normalize eder (supForm kopyası).
 * FormModulePromt §4.6. customer-panel/src/views/Pages/Forms/utils/formCompat.js ile aynı mantık.
 */

var FORM_DEFAULTS = {
    version: 2,
    theme: {},
    seo: {},
    meta: {},
};

var FORM_SETTINGS_DEFAULTS = {
    status: { enabled: true },
    conditions: [],
    uniqueSubmission: "none",
    formLayout: "one-page",
    showErrorNavigation: true,
    allowBrowserAutocomplete: false,
    copilotEnabled: true,
};

function normalizeFieldType(type) {
    if (type === "pageBreak") return "pagebreak";
    return type;
}

function ensureFieldDefaults(field) {
    var f = field || {};
    if (!f.type) return f;
    if (!Array.isArray(f.conditions)) {
        f.conditions = [];
    }
    if (f.parentBranchId === undefined) {
        f.parentBranchId = null;
    }
    return f;
}

function normalizeFormFromApi(rawForm) {
    if (!rawForm) return null;
    var form = Object.assign({}, rawForm);

    if (form.version == null) form.version = 1;
    if (!form.theme || typeof form.theme !== "object") form.theme = Object.assign({}, FORM_DEFAULTS.theme);
    if (!form.seo || typeof form.seo !== "object") form.seo = Object.assign({}, FORM_DEFAULTS.seo);
    if (!form.meta || typeof form.meta !== "object") form.meta = Object.assign({}, FORM_DEFAULTS.meta);

    if (!form.settings || typeof form.settings !== "object") {
        form.settings = Object.assign({}, FORM_SETTINGS_DEFAULTS);
    } else {
        if (!form.settings.status) form.settings.status = { enabled: true };
        if (!Array.isArray(form.settings.conditions)) form.settings.conditions = [];
        if (form.settings.uniqueSubmission == null) form.settings.uniqueSubmission = "none";
        if (form.settings.formLayout == null) form.settings.formLayout = "one-page";
        if (form.settings.showErrorNavigation == null) form.settings.showErrorNavigation = true;
        if (form.settings.allowBrowserAutocomplete == null) form.settings.allowBrowserAutocomplete = false;
        if (form.settings.copilotEnabled == null) form.settings.copilotEnabled = true;
    }

    return form;
}

function healBranchFieldReferences(fields) {
    if (!Array.isArray(fields) || !fields.length) return fields;

    var byId = {};
    fields.forEach(function (f) {
        if (f && f._id) byId[String(f._id)] = f;
    });

    return fields.map(function (f) {
        if (!f || f.type !== "branchSection") return f;

        var branchId = String(f._id);
        var bs = f.branchSection ? Object.assign({}, f.branchSection) : {};
        var childSet = {};
        var children = Array.isArray(bs.children) ? bs.children : [];

        children.forEach(function (cid) {
            var key = String(cid);
            if (byId[key]) childSet[key] = true;
        });

        fields.forEach(function (child) {
            if (!child || !child._id) return;
            if (String(child.parentBranchId) === branchId) {
                childSet[String(child._id)] = true;
            }
        });

        bs.children = Object.keys(childSet);
        return Object.assign({}, f, { branchSection: bs });
    });
}

function normalizeFieldsFromApi(rawFields) {
    if (!Array.isArray(rawFields)) return [];
    var sorted = rawFields.slice().sort(function (a, b) {
        return (a.order || 0) - (b.order || 0);
    });
    var mapped = sorted.map(function (raw) {
        var field = Object.assign({}, raw);
        field.type = normalizeFieldType(field.type);
        if (field.parentBranchId != null) {
            field.parentBranchId = String(field.parentBranchId);
        }
        if (field.branchSection && Array.isArray(field.branchSection.children)) {
            field.branchSection = Object.assign({}, field.branchSection, {
                children: field.branchSection.children.map(function (cid) {
                    return cid != null ? String(cid) : cid;
                }).filter(Boolean),
            });
        }
        return ensureFieldDefaults(field);
    });
    return healBranchFieldReferences(mapped);
}

function buildFieldsById(fields) {
    var map = {};
    if (!Array.isArray(fields)) return map;
    fields.forEach(function (f) {
        if (f && f._id) map[String(f._id)] = f;
    });
    return map;
}

export {
    normalizeFormFromApi,
    normalizeFieldsFromApi,
    buildFieldsById,
    normalizeFieldType,
};

export default {
    normalizeFormFromApi: normalizeFormFromApi,
    normalizeFieldsFromApi: normalizeFieldsFromApi,
    buildFieldsById: buildFieldsById,
    normalizeFieldType: normalizeFieldType,
};
